import { useQuery } from "react-query";
import { AdminJobDetailResponse } from "../../../../models/Job";
import { getApiInstance } from "../../../api";
import queryWrapper from "../../queryWrapper";
import ApiClient from "../../../apiClient";

export const fetchAdminAllJobKey = "all-admin-job-key";

export async function fetchAdminAllJob(): Promise<AdminJobDetailResponse[]> {
  const res = await ApiClient.get(`/AdminAllJobDetail`);
  return res.data;
}

export default function useFetchAdminAllJob() {
  return useQuery([fetchAdminAllJobKey], queryWrapper(fetchAdminAllJob));
}
